<script setup lang="ts">
defineProps<{
	name: string
	color?: string | null
}>()
</script>

<template>
	<div
		class="w-fit rounded px-2 py-0.5 text-xs font-medium text-white"
		:style="{ backgroundColor: color ?? '#3788d8' }"
	>
		{{ name }}
	</div>
</template>
